import { render, staticRenderFns } from "./ItemChipNew.vue?vue&type=template&id=8eddff26&scoped=true"
import script from "./ItemChipNew.vue?vue&type=script&lang=ts"
export * from "./ItemChipNew.vue?vue&type=script&lang=ts"
import style0 from "./ItemChipNew.vue?vue&type=style&index=0&id=8eddff26&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eddff26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eddff26')) {
      api.createRecord('8eddff26', component.options)
    } else {
      api.reload('8eddff26', component.options)
    }
    module.hot.accept("./ItemChipNew.vue?vue&type=template&id=8eddff26&scoped=true", function () {
      api.rerender('8eddff26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ItemChipNew.vue"
export default component.exports